/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnalyticMapData } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AnalyticMapDataServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get the AnalyticMapData by Procedure.
     * Returns AnalyticMapData with a procedure. The procedureName of  is required as a parameter for the method.
     * @param procedureName The name of the procedure responsible for filtering the AnalyticMapData
     * @param requestBody 
     */
    getAnalyticMapDataByProcedure(procedureName: string, requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<Array<AnalyticMapData>>;

    /**
     * Get all filtered analytic map data
     * Returns all filtered analytic map data depending on their filter
     * @param analyticProcessId ID of the analytic process
     */
    getAnalyticMapDataFilterDefault(analyticProcessId: number, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Get the current AnalyticMapData.
     * Returns the current software AnalyticMapData for a specific analyticProcessID. The ID of the analytic process is required as a parameter for the method.
     * @param analyticProcessId ID of the analytic process
     */
    getCurrentAnalyticMapDataByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticMapData>>;

    /**
     * Returns all filtered analytic map data
     * Returns all filtered analytic map data depending on their filter
     * @param analyticProcessId ID of the analytic process
     * @param requestBody 
     */
    getFilteredAnalyticMapData(analyticProcessId: number, requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<Array<AnalyticMapData>>;

    /**
     * Returns all filtered analytic map data by default value
     * Returns all filtered analytic map data based on the default value for the provided analyticProcessId.
     * @param analyticProcessId ID of the analytic process
     */
    getFilteredAnalyticMapDataByDefaultValue(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticMapData>>;

    /**
     * Returns all filtered analytic map data based on pre-filtered data
     * Returns all filtered analytic data based on pre-filtered data identified by the specified analyticFilterDefinitionId and filter.
     * @param analyticFilterDefinitionId ID of the analytic filter definition
     * @param structureIds A list of structure IDs to filter the results
     */
    getFilteredAnalyticMapDataByPreFilteredData(analyticFilterDefinitionId: number, structureIds: Array<number>, extraHttpRequestParams?: any): Observable<Array<AnalyticMapData>>;

}
